(() => {
  const names = window.filameltPropertyNames;
  if (!names) return;
  const root = window.Shopify?.routes?.root || '/';
  const translate = properties => {
    const result = {...properties};
    for (const [key, name] of Object.entries(names)) {
      if (!Object.hasOwn(result, key)) continue;
      if (Object.hasOwn(result, name) && result[name] !== result[key]) throw new Error('PROPERTY_NAME_CONFLICT');
      result[name] = result[key];
      delete result[key];
    }
    if (names[result._gpo_field_name]) result._gpo_field_name = names[result._gpo_field_name];
    return result;
  };
  const main = document.getElementById('MainContent');
  const messages = window.filameltPropertyMessages;
  if (!main || !messages) return;
  const status = document.createElement('p');
  status.setAttribute('role', 'status');
  const lock = () => {
    main.inert = true;
    status.textContent = messages.busy;
    main.before(status);
  };
  const identity = cart => JSON.stringify(cart.items.map(item => ({
    key:item.key, quantity:item.quantity, properties:item.properties
  })));
  const read = async () => {
    const response = await fetch(`${root}cart.js`, {cache:'no-store', headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('CART_READ_FAILED');
    return response.json();
  };
  const run = async () => {
    let expected = await read();
    const updates = expected.items.filter(item => Object.keys(item.properties || {}).some(key => names[key]) || names[item.properties?._gpo_field_name]);
    if (!updates.length) return;
    lock();
    updates.forEach(item => translate(item.properties));
    for (const item of updates) {
      const current = await read();
      if (identity(current) !== identity(expected)) throw new Error('CART_CHANGED');
      const changed = await fetch(`${root}cart/change.js`, {
        method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
        body:JSON.stringify({id:item.key, quantity:item.quantity, properties:translate(item.properties)})
      });
      if (!changed.ok) throw new Error('CART_UPDATE_FAILED');
      expected = await changed.json();
    }
    location.reload();
  };
  const fail = () => {
    lock();
    status.setAttribute('role', 'alert');
    status.textContent = messages.error + ' ';
    const retry = document.createElement('button');
    retry.type = 'button';
    retry.textContent = messages.retry;
    retry.addEventListener('click', () => location.reload());
    status.append(retry);
  };
  window.filameltPropertyMigration = run().catch(fail);
})();
